<template>
    <div class="card-group">
        <app-dashboard-item
            v-for="item in displayItems"
            :item="item"
            :key="item.name"
            @setSetpoint="setSetpoint"
        ></app-dashboard-item>
    </div>
</template>

<script>
import axios from "axios";
import DashboardItem from "./DashboardItem.vue";

export default {
    data() {
        return {
            controllerList: [],
            sensorList: [],
            actuatorList: [],
            displayItems: [],
            numberOfContacts: 0,
            timer: "",
        };
    },
    created() {
        const title = this.getTitle(this);
        if (title) {
            document.title = title;
        }
        this.timer = setInterval(this.loadData, 30000);
    },

    beforeDestroy() {
        console.log("beforeDestroyed");
        clearInterval(this.timer);
    },

    components: {
        appDashboardItem: DashboardItem,
    },

    computed: {},

    mounted() {
        this.loadData();
    },

    methods: {
        getControllers() {
            const app = this;
            return axios
                .get("/master/controller_list")
                .then((res) => {
                    app.controllerList = res.data;
                    return { data: res, sucsess: true };
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getActuators() {
            const app = this;
            return axios
                .get("/master/actuator_list")
                .then((res) => {
                    app.actuatorList = res.data;
                    return { data: res, sucsess: true };
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getSensors() {
            const app = this;
            return axios
                .get("/master/sensor_list")
                .then((res) => {
                    app.sensorList = res.data;
                    return { data: res, sucsess: true };
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        loadData() {
            const app = this;

            const config = [
                {
                    fbc: "FBC_DG_Kind_Links",
                    sensor: "TS_DG_Kind_Links",
                    switch: "R_DG_Kinder_Links",
                },
                {
                    fbc: "FBC_DG_Kind_Rechts",
                    sensor: "TS_DG_Kind_Rechts",
                    switch: "R_DG_Kinder_Rechts",
                },
                {
                    fbc: "FBC_DG_Eltern",
                    sensor: "TS_DG_Eltern",
                    switch: "R_DG_Eltern",
                },
                {
                    fbc: "FBC_DG_Gang",
                    sensor: "TS_DG_Gang",
                    switch: "",
                },
                { fbc: "FBC_OG_FBH", sensor: "TS_OG_Wohnkueche", switch: "" },
                {
                    fbc: "FBC_EG_Buero",
                    sensor: "TS_EG_Buero",
                    switch: "R_EG_Buero",
                },
                {
                    fbc: "FBC_EG_Salon",
                    sensor: "TS_EG_Salon",
                    switch: "R_EG_Salon",
                },
            ];

            Promise.all([
                app.getControllers(),
                app.getActuators(),
                app.getSensors(),
            ])
                .then(function (responses) {
                    // Notihng to do
                })
                .then(() => {
                    let newDisplayItems = [];
                    config.forEach((element) => {
                        let c = app.controllerList[element["fbc"]];
                        let s = app.sensorList[element["sensor"]];
                        let a = app.actuatorList[element["switch"]];

                        var data = {
                            fbc_name: c.name,
                            fbc_alias: c.alias.replace("FBC", ""),
                            fbc_setpoint: c.setpoint,
                            fbc_status: app.transformState(c.state),
                            fbc_statusname: c.state,
                            s_reading: s.reading,
                            s_unit: s.unit,
                            s_timestamp: s.timestamp,
                            s_name: s.name,
                            s_alias: s.alias,
                        };
                        if (a != null) {
                            (data.a_name = a.name),
                                (data.a_alias = a.alias),
                                (data.a_status = app.transformState(a.state));
                        }

                        newDisplayItems.push(data);
                        app.displayItems = newDisplayItems;
                    });
                })

                .catch(function (error) {
                    // if there's an error, log it
                    console.log(error);
                });
        },

        cancelAutoUpdate() {
            clearInterval(this.timer);
        },

        setSetpoint(e) {
            //const app = this;
            var url = "/" + e.name;
            var data = {
                setpoint: e.setpoint,
            };
            return axios
                .put(url, data, {
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                        Authorization:
                            "Bearer W0OEQlXdO8KqXb-WjmJaBA9tZGxCLGQt3oc58qGUKXKysvDP7BSQRLC_ixJXWQgz4jkZptJJuqV8Zam0Hk_sDA6mF2Wh9E9VYjc30NJuMRxdxKCK5k6nMxZqDTNXpMowd8-CIltsdWoP0bdtelY5s505CCEGhud2wBdh4ovRNyigBZsK4vJ-uAPSorVc-cR8XxzXTIbwUgfRCqiHxmpqi_v4SNjVQIxCqHvGVec2x_bJKecu1jS4pSQA4jxB9KsEbbVCw3-ExjS3BC69yuSIaH8SzBzOTpHR2igHbGP2X6zk2s-jVkBRIigENqXiW_eqNBecewpj9-H5zW3pDG4kfw",
                    },
                })
                .then((res) => {
                    this.loadData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getTitle(vm) {
            const { title } = vm.$options;
            if (title) {
                return typeof title === "function" ? title.call(vm) : title;
            }
        },

        transformState(value) {
            switch (value) {
                case "ON::ABOVE_SETPOINT":
                case "OFF":
                    return false;

                default:
                    return true;
            }
        },
    },
};
</script>

<style scoped>
</style>